<template>
  <div class="tooltip-container" :style="positionStyle">
    <div class="tooltip-title">
      {{ title || '' }}
    </div>
    <div
      v-for="lineItem in lineItems"
      :key="lineItem"
      class="tooltip-value"
      :class="{ indented: lineItem.isIndented }"
    >
      <div v-if="lineItem.color" :style="{ backgroundColor: lineItem.color }" class="tooltip-dot" />
      <span :class="{ bold: lineItem.isBold }">{{ lineItem.value || '' }}</span>
    </div>
    <div class="tooltip-caret" />
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  lineItems: {
    type: Array,
    default: () => [],
  },
  x: {
    type: Number,
    default: 0,
  },
  y: {
    type: Number,
    default: 0,
  },
  visible: {
    type: Boolean,
    default: false,
  },
});

const positionStyle = computed(() => ({
  left: `${props.x}px`,
  top: `${props.y}px`,
  opacity: props.visible ? 1 : 0,
  display: props.visible ? 'block' : 'none',
}));
</script>

<script>
export default { name: 'TooltipWebComponent' };
</script>

<style lang="less" scoped>
.tooltip-container {
  position: fixed;
  background: @white;
  color: @text-darkest;
  padding: 16px;
  border-radius: 4px;
  pointer-events: none;
  z-index: 2;
  transition: opacity 0.15s ease;
  transform: translate(-50%, -100%);
  margin-top: -8px;
  box-shadow: 0px 0px 6px 0px @grey-600;
}

.tooltip-title {
  font-size: 14px;
  line-height: normal;
  font-weight: 500;
  margin-bottom: 6px;
}

.tooltip-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 4px;
}

.tooltip-value {
  font-size: 13px;
  line-height: normal;
  margin-bottom: 6px;
  font-weight: 500;
  display: flex;
  align-items: center;

  span {
    opacity: 0.7;

    &.bold {
      font-weight: 800;
    }
  }

  &.indented {
    margin-left: 8px;
  }
}

.tooltip-caret {
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid @white;
}
</style>
